import * as React from 'react';

function SvgChevronRight(props) {
  return (
    <svg width={15} height={16} viewBox="0 0 15 16" fill="none" {...props}>
      <path
        d="M 5 2l6 6-6 6"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default SvgChevronRight;
